<template>
  <div class="mainDiv">
    <el-tabs v-model="reviewStatus" type="card">
      <el-tab-pane
        v-for="item in reviewStatusList"
        :key="item.value"
        :label="item.label"
        :name="item.name"
      ></el-tab-pane>
    </el-tabs>   
    <!-- 检索栏 -->
    <div class="tab">
      <div class="control">
        <el-col :span="6">   
            <el-input v-model="form.courseName"  placeholder="-请输入课程名称-"></el-input>
        </el-col>
        <el-col :span="6">
            <el-input v-model="form.examsPaperId" placeholder="-请输入试卷ID-"></el-input>
        </el-col>
        <el-button type="primary" size="mini" @click="search">确定</el-button>
        <el-button size="mini" @click="delAll"> 清空 </el-button>
      </div>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="50"
        align="center"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        label="试卷id"
        width="60"
        align="center"
        header-align="center"
        prop="examsPaperId"
      >
        <!-- <template slot-scope="scope">{{
          scope.$index + 1 + (pageObj.page - 1) * pageObj.pageSize
        }}</template> -->
      </el-table-column>
      <el-table-column
        prop="vid"
        label="课程ID"
        align="center"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="courseName"
        label="课程名称"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">
          <div style="color: #409eff; cursor: pointer">
            {{ scope.row.courseName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="examsPaperTitle"
        label="试卷名称"
        align="center"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="questionsCount"
        label="试题数"
        align="center"
        header-align="center"
        width="140"
      ></el-table-column>
       <el-table-column
        prop="score"
        label="总分数"
        align="center"
        header-align="center"
        width="140"
      ></el-table-column>
      <el-table-column
        prop="kkCount"
        :label="'开课人数'"
        align="center"
        header-align="center"
        width="140"
      ></el-table-column>
      <el-table-column
        prop="pkCount"
        label="排考人数"
        align="center"
        header-align="center"
        width="140"
      >
      </el-table-column>
      <el-table-column
        prop="ykCount"
        label="已考人数"
        align="center"
        header-align="center"
        width="140"
      ></el-table-column>
      <el-table-column
        prop="wkCount"
        label="未考人数"
        align="center"
        header-align="center"
        width="140"
      ></el-table-column>
      <el-table-column
        prop="uname"
        label="操作"
        width="200"
        align="center"

      >
        <template slot-scope="scope">
          <div class="table_control">
            <span
              class="table_control_item"
              @click="
                toLearningManagement(
                  '1',
                  scope.row.examsPaperId,
                  scope.row.courseName,
                  scope.row.examsPaperTitle,
                  scope.row.vid,
                )
              "
              >详情</span
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>




    <el-dialog
      title="导出筛选结果提示"
      :visible.sync="exportShow"
      width="30%">
      <div class="t_export">
        <div class="t_exportTitle">本次导出的结果数据为：<span class="t_count">{{total}}</span></div>
        <el-button type="primary" size='small' @click="handleConfirmExport">确 定</el-button>
        <el-button type="primary" size='small' @click="exportShow = false">返 回</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="设置考核结束时间："
      :visible.sync="scoreShow"
      class="score_status_time_dialog"
      width="370px"
      @close="handleReturn"
    >
      <div class="t_export">
        <el-form ref="formDate"  :model="formDate" :rules="formDateRule" label-width="130px" size="mini">
          <el-row>
            <el-col :span="24">
              <el-form-item prop="scoreStatusTime" label="考核结束时间：">
                <el-date-picker
                  v-model="formDate.scoreStatusTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 80%"

                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="t_exportTitle">注：本次选择设置考核结束课程数为：<span class="t_count">{{selectedList.length>0?selectedList.length:total}}</span></div>
        <el-button type="primary" size='small' @click="setScoreStatusTime">确 定</el-button>
        <el-button type="primary" size='small' @click="handleReturn">返 回</el-button>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="setScoreStatusTime">确定</el-button>
      </span> -->
    </el-dialog>




  </div>
</template>

<script>
// 综合测验接口
import * as api from '@/api/ExamManagement/ComprehensiveTestDetail'
import * as api1 from '@/api/courseware/checkCourseware'
import * as api3 from '@/api/ClassManagement/addClass.js'
import ClassOpeningListVue from '../../ClassManagement/Class-openingList.vue'
export default {
  components: {},
  data() {
    return {
      reviewStatusList: [{ value: '0', label: '综合测验', name: '0' }],
      reviewStatus: '0',

      form: {
        //检索参数 courseName,examsPaperId
        courseName:"",
        examsPaperId:"",

      },
      selectedList: [],
      tableData: [],
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      total: 0,
      videoTypeList:[], // 考试类别
      examinationTypeList:[], // 考试方式
      dateRange:[], // 考核时间
      exportShow: false, // 导出展示
      scoreShow: false,  // 展示设置考核结束时间
      formDate:{scoreStatusTime:''}, // 考核结束时间
      formDateRule:{scoreStatusTime:[
       { required: true, message: '请输入考核结束时间', trigger: 'blur' },
      ]},
      isSeach:false, // 是否进行了筛选
      userType:'', //  用户类型
      selectedListId:'', // 选中的id
      partnerInstitutionList: [],
      partnerSchoolList: [],
      rkTeacherNameNull: false, // 任课老师是否为空
      rkMhmNameNull: false ,// 任课机构是否为空
    }
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
       if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      if (window.location.host == 'fxl.sce.scut.edu.cn') {
        url = url + '/zk'
      }
      return url
    },
  },
  created() {
    this.getComprehensiveTestList()
    // this.getVideoTypes();
    // this.examinationTypes();
    // this.getUserByUid();
    // this.getPartnerInstitution();
    // this.getPartnerSchool();
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.enterQuery)
  },
  methods: {
     async getPartnerInstitution() {
      const { code, data } = (await api3.getPartnerInstitution()).data
      if (code === 100000) {
        this.partnerInstitutionList = data
        console.log('this.partnerInstitutionList', this.partnerInstitutionList)
      }
    },
    async getPartnerSchool() {
      const { code, data } = (await api3.getPartnerSchool()).data
      if (code === 100000) {
        this.partnerSchoolList = data
        console.log(' this.partnerSchoolList', this.partnerSchoolList, data)
      }
    },
    // getComprehensiveTestList
    async getComprehensiveTestList() {
      // 检索数据参数 courseName,examsPaperId
      console.log('forms',this.form)
      const { data, code } = (
        await api.getComprehensiveTestList({
          ...this.form,
          uid: this.getUId,
          ...this.pageObj,
        })
      ).data
      console.log("4546",data);
      if (code === 100000) {
        if(data.list.length> 0){
          console.log("请求数据===》",data);
          // this.tableData = data.list
          // this.tableData 
          data.list.map(async v =>{
            // z+
            const params = {
              examsPaperId: v.examsPaperId,
              vid: v.vid
            }
            const countNum = await this.getComprehensiveTestPeopleList(params)
            console.log(countNum);
            if( countNum && v.examsPaperId == countNum.examsPaperId){
                v.kkCount = countNum.kkCount
                v.pkCount = countNum.pkCount
                v.ykCount = countNum.ykCount
                v.wkCount = countNum.wkCount
            }else{
              v.kkCount = 0
              v.pkCount = 0
              v.ykCount = 0
              v.wkCount = 0
            }
          })
          this.tableData = data.list
          console.log('total', data.list)
          this.total = data.total
        }else{
           this.tableData = data.list
        }
        
      }
    },

    // 获取人数统计列表
    async getComprehensiveTestPeopleList(params){
       const { data, code } = (
        await api.getComprehensiveTestPeopleList(params)
      ).data
      if (code === 100000) {
        console.log("获取人数成功===》",data);
        return data[0]
      }
    },
    enterQuery(e) {
      if (e.key === 'Enter') {
        this.search()
      }
    },

    //搜索
    search() {
      this.pageObj.page = 1;
      this.getComprehensiveTestList();
      this.isSeach = true;
    },
        //清空搜索内容
    delAll() {
      this.form.courseName="",
      this.form.examsPaperId="",
      this.pageObj.page = 1
      this.getComprehensiveTestList()
    },
    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr;
      let ids = this.selectedList.map(v=>{return v.id})
      this.selectedListId = ids.join(',')
      // console.log('this',this.selectedListId)
      // console.log('selectedList',this.selectedList)
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getComprehensiveTestList()
    },
    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getComprehensiveTestList()
    },

    toLearningManagement(tab, examsPaperId,  courseName,examsPaperTitle,vid) {
     
      this.$router.push(
        `/ComprehensiveTestDetail?tab=${tab}&examsPaperId=${examsPaperId}&uid=${this.getUId}&courseName=${courseName}&examsPaperTitle=${examsPaperTitle}&vid=${vid}`
      )
    },


    // 点击确认导出筛选结果
    handleConfirmExport(){
      let forms = JSON.parse(JSON.stringify(this.form));
      forms.videoTypeTitle = this.form.videoTypeTitle==='-不限-'?'':this.form.videoTypeTitle;
      forms.examinationType = this.form.examinationType==='-不限-'?'':this.form.examinationType;
      forms.status = this.form.status==='-不限-'?'':this.form.status;
      // console.log('status',`${this.url}/zkfz/courseTeacherManage/exportExcel?courseName=${forms.courseName}&teacherName=${forms.teacherName}&mhName=${forms.mhName}&courseCode=${forms.courseCode}&classCode=${forms.classCode}&status=${forms.status}&uid=${this.getUId}&page=0&pageSize=${this.pageObj.pageSize}&videoTypeTitle=${forms.videoTypeTitle}&examinationType=${forms.examinationType}&courseAttribute=${forms.courseAttribute}&rkTeacherName=${forms.rkTeacherName}&rkMhmName=${forms.rkMhmName}&checkTimeBegin=${forms.checkTimeBegin}&checkTimeEnd=${forms.checkTimeEnd}`)
      // return;
      window.open(
        `${this.url}/zkfz/courseTeacherManage/exportExcel?courseName=${forms.courseName}&teacherName=${forms.teacherName}&mhName=${forms.mhName}&courseCode=${forms.courseCode}&classCode=${forms.classCode}&status=${forms.status}&uid=${this.getUId}&page=0&pageSize=${this.pageObj.pageSize}&videoTypeTitle=${forms.videoTypeTitle}&examinationType=${forms.examinationType}&courseAttribute=${forms.courseAttribute}&rkTeacherName=${forms.rkTeacherName}&rkMhmName=${forms.rkMhmName}&checkTimeBegin=${forms.checkTimeBegin}&checkTimeEnd=${forms.checkTimeEnd}`
      )
      this.exportShow = false;
    },
    // 获取考试类别
    async getVideoTypes(){
      let {data} = await api.getVideoType();
      if(data.code===100000){
        this.videoTypeList = data.data;
      }
      this.videoTypeList.unshift({videoTypeTitle:'-不限-'})
      // console.log('res',res)
    },
    // 获取考试方式
    async examinationTypes(){
      let {data} = await api.getBaseDictType();
      if(data.code===100000){
        this.examinationTypeList = data.data;
      }
      this.examinationTypeList.unshift({typeName:'-不限-'});
      //  console.log('res22',res)
    },
    // 设置考核结束时间
    setScoreStatusTime(){
      let that = this;
      this.$refs.formDate.validate(valid=>{
        if(valid){
          // let forms = this.form;
          let forms = JSON.parse(JSON.stringify(this.form));
          forms.videoTypeTitle = this.form.videoTypeTitle==='-不限-'?'':this.form.videoTypeTitle;
          forms.examinationType = this.form.examinationType==='-不限-'?'':this.form.examinationType;
          forms.status = this.form.status==='-不限-'?'':this.form.status;
          forms.page = 0;
          api.updateCheckTime(
            {
              ...forms,
              ids:that.selectedListId,
              checkTime:that.formDate.scoreStatusTime
            }
          ).then(res=>{
            if(res.data.code === 100000){
              this.$message({type:'success',message:'设置考核结束时间成功'})
              this.getComprehensiveTestList();
              this.scoreShow = false;
            }
            console.log('res23',res)
          });
        }
      })
    },
    // 获取用户类型
    getUserByUid() {
      api1.getUserByUid(this.getUId).then(({ data }) => {
        if (data.code === 100000) {
          this.userType = data.data.type
        }
      })
    },
    // 设置考核结束时间返回事件
    handleReturn(){
      this.scoreShow = false;
      this.formDate.scoreStatusTime = '';
      this.$refs.formDate.clearValidate();
    }

  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/classManagement.scss';
/deep/.el-collapse {
  padding-bottom: 20px;
}

.table_control {
  color: #409eff;
  .table_control_item {
    vertical-align: middle;
    cursor: pointer;
  }
}
/deep/ .el-table th > .cell {
  white-space: pre-wrap;
}
.t_export{
  margin: 0 auto;
  text-align: center;
}
.t_exportTitle{
  margin-bottom: 20px;
}
.t_count{
  color:red;
  font-weight: 600;
}
/deep/ .el-dialog__body{padding-top:18px}
/deep/ .el-dialog__header{background:#eeeeee}
</style>
